import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '../../../features/auth/auth-context';
import { CrmInstagramConnectPanel } from '../../../features/crm/components/crm-instagram-connect-panel';

export const Route = createFileRoute('/_authenticated/crm/instagram')({
  staticData: { breadcrumb: 'Instagram' },
  validateSearch: (search: Record<string, unknown>) => ({
    connected: typeof search.connected === 'string' ? search.connected : undefined,
    error: typeof search.error === 'string' ? search.error : undefined,
  }),
  component: InstagramPage,
});

function InstagramPage() {
  const { adminRoles } = useAuth();
  if (!adminRoles.includes('SUPERADMIN')) {
    return <Navigate to="/crm/conversations" />;
  }
  return <CrmInstagramConnectPanel />;
}
